// 正式
module.exports = {
  //title: 'krpano100',
  baseUrl: 'http://server.qwhouse720.com', // 正式項目地址
  baseApi: '/api'
}
